import { Command } from '@helios/commands'
import {
  RootIdType,
  TransactionTypeEnum,
  TransactionTypeKey,
} from '@helios/common-api'
import {
  BulkClearwaterTransaction,
  BulkCwTranUpdateActionType,
} from './clearwater-transaction.model'
export const BULK_CW_TRAN_LIMIT = 30_000

export interface BulkClearwaterTransactionsGetRequest {
  filter: BulkClearwaterTransactionsFilter
}

export interface BulkClearwaterTransactionsFilter {
  accountIds?: number[]
  clientIds?: number[]
  dateField?: BulkCwTranDateType
  beginDate?: string
  endDate?: string
  tranIds?: string[]
  assetIds?: string[]
  tranTypes?: TransactionTypeKey[]
  legacyTranIds?: number[]
}

export enum BulkCwTranDateType {
  entry = 'ENTRY',
  settle = 'SETTLE',
  post = 'POST',
  created = 'CREATED',
}
export type BulkCwTranDateTypeKey = keyof typeof BulkCwTranDateType

export interface FindBulkClearwaterTransactionsForm {
  rootIdType?: RootIdType
  rootIds?: string
  dateRangeType?: BulkCwTranDateType
  startDate?: string
  endDate?: string
  assetIds?: string
  tranTypes?: TransactionTypeKey[]
}

export interface UpdateBulkClearwaterTransactionsForm {
  transactions: {
    transactionId: string
    accountId: number
  }[]
  type: BulkCwTranUpdateActionType
}

export interface BulkClearwaterTransactionsUpdateResponse {
  transactionId: string
  successful: boolean
  messages: string[]
  commands: Command[]
}

export interface BulkClearwaterTransactionsGetResponse {
  data: BulkClearwaterTransaction[]
  matchingTransCount: string
}

export interface BulkClearwaterTranSetValues {
  parentIds: string[]
  tranTypes: TransactionTypeKey[]
  tranTypeCodes: string[]
}

export interface BulkCwTranTypeSetValue {
  type: TransactionTypeKey
  name: TransactionTypeEnum
}
